import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { Router, RouterOutlet, RouterLink, NavigationStart, Event } from '@angular/router';

import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FlexModule } from '@ngbracket/ngx-layout/flex';
import { ExtendedModule } from '@ngbracket/ngx-layout/extended';

import { AuthService } from './auth.service';
import { DeezerLoginPromptService } from './shared/deezer-login-prompt.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true,
  imports: [
    RouterOutlet,
    RouterLink,
    FormsModule,
    MatIconModule,
    MatSidenavModule,
    MatProgressBarModule,
    MatMenuModule,
    MatToolbarModule,
    MatListModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatChipsModule,
    MatSnackBarModule,
    MatDividerModule,
    MatTooltipModule,
    FlexLayoutModule,
    FlexModule,
    ExtendedModule
]
})
export class AppComponent {
  title = 'web422-a4';
  searchString: string = '';
  songSearchString: string = '';
  public token = signal<any>(null);

  constructor(
    private router: Router,
    private auth: AuthService,
    protected deezerPrompt: DeezerLoginPromptService
  ) { }

  ngOnInit() {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.token.set(this.auth.readToken());
      }
    });
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['/login']);
  }

  handleSongSearch() {
    const query = this.songSearchString.trim();
    if (!query) return;
    this.router.navigate(['/songs', query]);
    this.songSearchString = '';
  }

  handleSearch() {
    this.router.navigate(['/search', this.searchString]);
    this.searchString = '';
  }
}
